import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../Hooks/useAuth';
import { ROUTES } from '../Utils/constants';

// This component protects routes based on user roles
const RoleRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();
  
  // Ensure user exists and has at least one allowed role
  if (!user || !user.roles.some(role => allowedRoles.includes(role))) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return children;
};

export default RoleRoute;
